
import React from "react";
import { useEffect } from "react";
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Figure from 'react-bootstrap/Figure';
import getImageByKey from './getImageByKey';
import Aos from "aos";
import "aos/dist/aos.css";



const Mycard = (props) => {
  useEffect(
  () =>{
    Aos.init({ duration: 1000});
  },[]
  );
  const alertFunction = () =>{
    alert("Coming Soon")
  }
  return (  

  <Col className="col-10 col-lg-6 offset-1 offset-lg-0 text-white "  data-aos="flip-right">
  <Card   >
     
      <Card.Body>

      <i class={props.icon} aria-hidden="true"></i>
      <span className="ms-1">{props.tittle}</span>
        <Figure>
      <Figure.Image
        
        alt="171x180"
      src={getImageByKey(props.img)}
      />

    </Figure>
        <Card.Text>
      <p>{props.description}</p>
        </Card.Text>
        <div class="contain" >
        {props.btn && <a className='aa' href={props.link}>
       <span onClick={props.type === "alert" ? alertFunction : null}>{props.btn}</span>
    </a>}
   
    </div>
      </Card.Body>
    </Card>
  </Col>




  );
}
 
export default Mycard;